import { render, staticRenderFns } from "./Pedido_Proveedor.vue?vue&type=template&id=2d1112c8&scoped=true"
import script from "./Pedido_Proveedor.vue?vue&type=script&lang=js"
export * from "./Pedido_Proveedor.vue?vue&type=script&lang=js"
import style0 from "./Pedido_Proveedor.vue?vue&type=style&index=0&id=2d1112c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1112c8",
  null
  
)

export default component.exports